import { ErrorType, ValidationErrorDto } from '@/types/error.type';
import { SerializedError } from '@reduxjs/toolkit';

class CustomError extends Error {
  // error;
  status = 1;
  message = '';
  // message: string[] | string | undefined;
  timestamp = 0;
  method = '-';
  path = '-';
  stack = '-';
  validations = [] as ValidationErrorDto[];
  hidden = false;
  ttl = 3000;
  constructor(
    public _error?:
      | ErrorType
      | { status: number; message: string | string[]; error: string }
      | SerializedError
      | undefined,
  ) {
    if (!_error) return;
    const error = ('data' in _error ? _error.data : _error) as ErrorType;

    // console.log({ error });
    super(('message' in error && error.message) || 'CustomError');
    if ('error' in error) {
      this.status = 503;
      this.name = 'Fetch Error';
      this.message = 'Server not response.';
    } else {
      this.status = ('status' in error && error.status) || 1;
      this.name = ('name' in error && error.name) || 'Custom Error';
      this.message = ('message' in error && String(error.message)) || 'Custom Error';
    }
    this.timestamp = ('timestamp' in error && Number(error.timestamp)) || new Date().getTime();
    this.stack = ('stack' in error && error.stack) || '-';
    this.path = ('path' in error && error.path) || '-';
    this.method = ('method' in error && error.method) || '';
    this.validations = ('validations' in error && error.validations) || [];
    this.hidden = ('hidden' in error && error.hidden) || false;
    this.ttl = ('ttl' in error && error.ttl) || 3000;
  }
  toObject() {
    return JSON.parse(JSON.stringify(this)) as ErrorType;
  }
}

export default CustomError;
